import api from "@/services/api";

/****************
 * Apps builder
 ****************/

export default {
  getPages() {
    return api.get(`/api/v1/pages`);
  },
  createPage(data) {
    return api.post(`/api/v1/pages`, data);
  },

  getPage(id) {
    return api.get(`/api/v1/page?id=${id}`);
  },

  updatePage(data) {
    //page id is verplicht
    return api.put(`/api/v1/page`, data);
  },

  deletePage(id) {
    return api.delete(`/api/v1/page?id=${id}`);
  },

  getPageWidgets(pageId, appId) {
    return api.get(`/api/v1/widgets?page_id=${pageId}`);
  }
};
